import React from "react";
import "./Home.css";
// import i from '../../assets/sec1'

const Home = () => {
  return (
    <div className="H-div">
      {/* <img src={i} alt="" /> */}
      <div className="main">
      <div className="heading">
        <h1 className="heading1">REDPHANTOM TECH NOVELTY</h1>
        <h2 className="heading2">WE HAVE EXTREMELY EFFECTIVE IT <br /> SOLUTION FOR YOUR INDUSTRY</h2>
      </div>
      <div className="para">
        <p>
          Our top goal is to ensure that the requirements of our customers
          remain our top priority at all times throughout the process of
          integrating new features into our current services as we expand our
          service offerings.
        </p>
        <p>
          Consequently, we will be in a better position to react to the changing
          requirements of our customers and to provide them with better service
          in the future. Consequently, we consistently exceed our client's
          expectations by exceeding their needs, and we take care of any extra
          problems that occur on their behalf. Every aspect of our activity is
          overseen by a service sector organization, which is responsible for
          all aspects of our work. This organization is in charge of putting
          policies in place, executing program and accesing reukts on the field.
        </p>
        <p>
          Consequently, we will be in a better position to react to the changing
          requirements of our customers and to provide them with better service
          in the future. Consequently, we consistently exceed our client's
          expectations by exceeding their needs, and we take care of any extra
          problems that occur on their behalf. Every aspect of our activity is
          overseen by a service sector organization, which is responsible for
          all aspects of our work. This organization is in charge of putting
          policies in place, executing program and accesing reukts on the field.
        </p>
      </div>
      </div>
    </div>
  );
};

export default Home;
